// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/flag.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Контейнер заголовка */
.Header_headerContainer__Q5iwg {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover; /* Заполнение всего контейнера */
  background-position: center; /* Центрирование изображения */
  background-repeat: no-repeat; /* Отключаем повторение */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* Затемняющий оверлей */
.Header_overlay__KUm9A {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Полупрозрачный чёрный фон */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center; /* Центрируем текст */
  padding: 20px;
  box-sizing: border-box;
}

/* Заголовок */
.Header_headerH__i8wpE {
  font-family: "Ysabeau SC", sans-serif;
  font-weight: 900;
  font-size: 4rem; /* Крупный шрифт */
  line-height: 1.2;
  color: white; /* Белый цвет текста */
  text-transform: uppercase;
  margin: 0; /* Убираем отступы */
}

/* Описание */
.Header_headerDescription__ymLuA {
  font-family: "Open Sans", sans-serif;
  font-size: 1.5rem; /* Размер текста */
  color: white;
  margin-top: 1rem; /* Отступ сверху */
  max-width: 70%; /* Ограничение ширины текста */
}

/* Адаптивные стили */
@media (max-width: 730px) {
  .Header_headerH__i8wpE {
    font-size: 2.5rem; /* Уменьшаем размер заголовка */
  }

  .Header_headerDescription__ymLuA {
    font-size: 1.2rem; /* Уменьшаем размер текста */
    margin-top: 1.5rem; /* Увеличиваем отступ сверху */
    margin-bottom: 2rem; /* Увеличиваем отступ снизу */
    line-height: 1.6; /* Увеличиваем межстрочный интервал */
    max-width: 95%; /* Ограничиваем ширину текста */
  }

  .Header_headerImg__P0Wi8 {
    width: 80%; /* Увеличиваем ширину изображения для маленьких экранов */
    margin-bottom: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/mainPage/Header/Header.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yDAA2D;EAC3D,sBAAsB,EAAE,gCAAgC;EACxD,2BAA2B,EAAE,8BAA8B;EAC3D,4BAA4B,EAAE,yBAAyB;EACvD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,8BAA8B;EAC9D,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB,EAAE,qBAAqB;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe,EAAE,kBAAkB;EACnC,gBAAgB;EAChB,YAAY,EAAE,sBAAsB;EACpC,yBAAyB;EACzB,SAAS,EAAE,oBAAoB;AACjC;;AAEA,aAAa;AACb;EACE,oCAAoC;EACpC,iBAAiB,EAAE,kBAAkB;EACrC,YAAY;EACZ,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,8BAA8B;AAChD;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,iBAAiB,EAAE,4BAA4B;IAC/C,kBAAkB,EAAE,8BAA8B;IAClD,mBAAmB,EAAE,6BAA6B;IAClD,gBAAgB,EAAE,qCAAqC;IACvD,cAAc,EAAE,+BAA+B;EACjD;;EAEA;IACE,UAAU,EAAE,yDAAyD;IACrE,qBAAqB;EACvB;AACF","sourcesContent":["/* Контейнер заголовка */\r\n.headerContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-image: url(\"../../../../public/images/flag.jpg\");\r\n  background-size: cover; /* Заполнение всего контейнера */\r\n  background-position: center; /* Центрирование изображения */\r\n  background-repeat: no-repeat; /* Отключаем повторение */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Затемняющий оверлей */\r\n.overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5); /* Полупрозрачный чёрный фон */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center; /* Центрируем текст */\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Заголовок */\r\n.headerH {\r\n  font-family: \"Ysabeau SC\", sans-serif;\r\n  font-weight: 900;\r\n  font-size: 4rem; /* Крупный шрифт */\r\n  line-height: 1.2;\r\n  color: white; /* Белый цвет текста */\r\n  text-transform: uppercase;\r\n  margin: 0; /* Убираем отступы */\r\n}\r\n\r\n/* Описание */\r\n.headerDescription {\r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-size: 1.5rem; /* Размер текста */\r\n  color: white;\r\n  margin-top: 1rem; /* Отступ сверху */\r\n  max-width: 70%; /* Ограничение ширины текста */\r\n}\r\n\r\n/* Адаптивные стили */\r\n@media (max-width: 730px) {\r\n  .headerH {\r\n    font-size: 2.5rem; /* Уменьшаем размер заголовка */\r\n  }\r\n\r\n  .headerDescription {\r\n    font-size: 1.2rem; /* Уменьшаем размер текста */\r\n    margin-top: 1.5rem; /* Увеличиваем отступ сверху */\r\n    margin-bottom: 2rem; /* Увеличиваем отступ снизу */\r\n    line-height: 1.6; /* Увеличиваем межстрочный интервал */\r\n    max-width: 95%; /* Ограничиваем ширину текста */\r\n  }\r\n\r\n  .headerImg {\r\n    width: 80%; /* Увеличиваем ширину изображения для маленьких экранов */\r\n    margin-bottom: 1.5rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `Header_headerContainer__Q5iwg`,
	"overlay": `Header_overlay__KUm9A`,
	"headerH": `Header_headerH__i8wpE`,
	"headerDescription": `Header_headerDescription__ymLuA`,
	"headerImg": `Header_headerImg__P0Wi8`
};
export default ___CSS_LOADER_EXPORT___;
